export default "/images/arcax_bank.png?4a3a21bfb8d3335e499ec57fe03d3b1d";